import { c as _c } from "react/compiler-runtime";
import { useChains } from "@opensea/app-kit";
import { Avatar, Item, ItemContent, ItemSide, ItemTitle } from "@opensea/next-ui-kit";
import { FlexCenter, FlexColumn, TextBody, Tooltip, tv } from "@opensea/ui-kit";
import { Sensors } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
const statusBadge = tv({
  base: "rounded px-1.5 py-0.5",
  variants: {
    status: {
      Active: "bg-success-1-transparent-1 text-success-1",
      Degraded: "bg-error-1-transparent-1 text-error-1",
      Beta: "bg-caution-transparent-1 text-caution",
      "Coming Soon": "bg-bg-additional-1 text-text-secondary"
    }
  },
  defaultVariants: {
    status: "Active"
  }
});
const betaChains = [];
export function NetworksHoverable() {
  const $ = _c(6);
  const t = useTranslations("NetworksHoverable");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <NetworkContent />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Sensors size={16} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("networks");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <Tooltip content={t0}><FlexCenter className="gap-1" color="text-secondary">{t1}<TextBody size="xs">{t2}</TextBody></FlexCenter></Tooltip>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function NetworkContent() {
  const $ = _c(20);
  const {
    evmChains,
    getChainName
  } = useChains();
  const t = useTranslations("NetworksHoverable");
  let t0;
  if ($[0] !== t) {
    t0 = t("allNetworks");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="px-2 py-1.5">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== evmChains || $[5] !== getChainName) {
    let t3;
    if ($[7] !== getChainName) {
      t3 = t4 => {
        const {
          identifier
        } = t4;
        return <NetworkItem identifier={identifier} key={identifier} name={getChainName(identifier)} status="Active" />;
      };
      $[7] = getChainName;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = evmChains.map(t3);
    $[4] = evmChains;
    $[5] = getChainName;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[9] !== evmChains || $[10] !== getChainName || $[11] !== t) {
    let t4;
    if ($[13] !== getChainName || $[14] !== t) {
      t4 = t5 => {
        const {
          identifier: identifier_1
        } = t5;
        return <Tooltip content={t("tooltip")} key={identifier_1}><span><NetworkItem identifier={identifier_1} key={identifier_1} name={getChainName(identifier_1)} status="Beta" /></span></Tooltip>;
      };
      $[13] = getChainName;
      $[14] = t;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    t3 = evmChains.filter(_temp).map(t4);
    $[9] = evmChains;
    $[10] = getChainName;
    $[11] = t;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
    t4 = <FlexColumn className="w-[280px] font-sans">{t1}{t2}{t3}</FlexColumn>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  return t4;
}
function _temp(t0) {
  const {
    identifier: identifier_0
  } = t0;
  return betaChains.includes(identifier_0);
}
function NetworkItem(t0) {
  const $ = _c(17);
  const {
    identifier,
    status,
    name
  } = t0;
  const {
    getLogo
  } = useChains();
  let t1;
  if ($[0] !== getLogo || $[1] !== identifier) {
    t1 = getLogo(identifier);
    $[0] = getLogo;
    $[1] = identifier;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const logo = t1;
  let t2;
  if ($[3] !== logo) {
    t2 = <Avatar {...logo} size={20} />;
    $[3] = logo;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== name) {
    t3 = <ItemContent><ItemTitle>{name}</ItemTitle></ItemContent>;
    $[5] = name;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== status) {
    t4 = statusBadge({
      status
    });
    $[7] = status;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== status || $[10] !== t4) {
    t5 = <ItemSide><ItemTitle className={t4}>{status}</ItemTitle></ItemSide>;
    $[9] = status;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== identifier || $[13] !== t2 || $[14] !== t3 || $[15] !== t5) {
    t6 = <Item className="px-2 py-1.5" key={identifier} variant="unstyled">{t2}{t3}{t5}</Item>;
    $[12] = identifier;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}